import Phone from './phone';
import Email from './email';
import Ok from './ok';

export default {
  phoneNoBox: Phone,
  emailNoBox: Email,
  okNoBox: Ok,
};
